import bg1 from "../assets/images/bg_1.png";
import bg2 from "../assets/images/bg_2.png";
import QROrderPhone from "../assets/images/qrOrderPhone.png";
import QROrderPhone2 from "../assets/images/qrOrderPhone2.png";
import QROrderPhone3 from "../assets/images/qrOrderPhone3.png";
import ContactCTA from "../components/ContactCTA";

function QROrder() {
  return (
    <div
      id="background"
      style={{ backgroundImage: `url(${bg1})`, backgroundSize: "100% auto", backgroundRepeat: "no-repeat", backgroundPosition: "0 -200px" }}
    >
      <section className="py-12 px-4 md:py-20 text-left md:-mb-1" id="home">
        <div className="container mx-auto max-w-6xl">
          <div className="md:flex md:gap-12">
            <div className="md:w-11/12">
              <p className="text-xl font-semibold text-gray-800 pt-2">VernPOS QR Ordering</p>

              <h2 className="text-4xl md:text-6xl font-bold text-vern my-4">Let Your Customer Order Instantly</h2>

              <p className="text-lg text-gray-600">Increase turnover, reduce wait times, and streamline your operations with VernPOS QR Ordering.</p>

              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mt-8">
                <a
                  href="/contact-us"
                  className="border-2 border-vern text-vern hover:text-red-600 hover:border-red-200 py-3 rounded-full text-lg font-medium inline-block md:w-1/3 text-center"
                >
                  Request Demo
                </a>
                <a
                  href="https://pos.vernpos.my/business/register?package=6"
                  className="bg-vern hover:bg-red-100 text-white py-3 rounded-full text-lg font-medium inline-block md:w-1/3 text-center"
                >
                  Get Started
                </a>
              </div>
            </div>

            <div className="md:w-1/2 flex justify-center md:justify-end">
              <img src={QROrderPhone} alt="QR Ordering on Phone" className="w-full max-w-md mt-8 md:mt-0" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 px-4 md:py-16 bg-white">
        <div className="container mx-auto max-w-6xl">
          {/* Header */}
          <p className="text-xl font-semibold text-gray-800">VernPOS QR Ordering</p>

          <h2 className="text-4xl md:text-6xl font-bold text-vern my-4">Beautiful, Fast, and Made for Real Restaurants</h2>

          <p className="text-lg text-gray-600">
            From browsing the menu to customizing orders, everything is designed to be fast, intuitive, and frustration free.
          </p>

          {/* Cards */}
          <div className="grid md:grid-cols-2 gap-8 mt-12">
            {/* Left Card */}
            <div className="bg-vern rounded-3xl pt-10 px-8 flex flex-col items-center overflow-hidden">
              <h3 className="text-4xl font-semibold text-white text-center mb-8">Seamless Ordering Experience</h3>

              <img src={QROrderPhone2} alt="QR Ordering" className="w-full max-w-md mt-auto " />
            </div>

            {/* Right Card */}
            <div className="bg-[#FCF4F3] rounded-3xl p-10 flex items-center justify-center">
              <img src={QROrderPhone3} alt="QR Ordering Payment" className="w-full max-w-md" />
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-12 px-4 md:py-16 bg-[#F6F6F7]"
        style={{
          backgroundImage: `url(${bg2})`,
          backgroundSize: "100% auto",
          backgroundRepeat: "repeat",
          backgroundPosition: "0 -200px",
          borderWidth: "2px",
          borderColor: "#EDEDED",
          borderStyle: "solid",
        }}
      >
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <p className="text-xl font-semibold text-gray-800">VernPOS QR Ordering</p>

          <h2 className="text-4xl md:text-6xl font-bold text-vern mt-4 mb-12">How It Works</h2>

          {/* Steps */}
          <div className="space-y-10">
            {/* Step 1 */}
            <div className="flex items-start gap-6">
              <div className="flex shrink-0 items-center justify-center w-12 h-12 rounded-full bg-vern text-white font-bold text-lg">1</div>

              <div>
                <h3 className="text-2xl font-semibold text-gray-900">Place QR Codes on Tables</h3>
                <p className="text-gray-600 mt-1">Guests scan using their own phones. No app needed.</p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start gap-6">
              <div className="flex shrink-0 items-center justify-center w-12 h-12 rounded-full bg-vern text-white font-bold text-lg">2</div>

              <div>
                <h3 className="text-2xl font-semibold text-gray-900">Guests Browse & Order</h3>
                <p className="text-gray-600 mt-1">Smart menu optimized for mobile and upselling.</p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start gap-6">
              <div className="flex shrink-0 items-center justify-center w-12 h-12 rounded-full bg-vern text-white font-bold text-lg">3</div>

              <div>
                <h3 className="text-2xl font-semibold text-gray-900">Orders Go Directly to Your POS</h3>
                <p className="text-gray-600 mt-1">Instant sync with kitchen, barista, and cashier screens.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 px-4 md:py-16 bg-white" id="home">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <p className="text-xl font-semibold text-gray-800">VernPOS QR Ordering</p>

          <h2 className="text-4xl md:text-6xl font-bold text-vern mt-4 mb-12">Why Businesses Love QR Ordering</h2>

          {/* List */}
          <div className="divide-y divide-gray-200">
            {/* Row 1 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">1</span>

                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Faster Turnover</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">Customers order immediately → no waiting for staff.</p>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">2</span>
                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Increased Revenue</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">Smart upsells, recommended add-ons, and combos.</p>
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">3</span>
                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Reduced Labor Pressure</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">Your team focuses on service, not taking orders.</p>
            </div>

            {/* Row 4 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">4</span>
                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Accurate Order</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">No handwriting mistakes — everything is digital and clear.</p>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-8">
        <ContactCTA />
      </div>
    </div>
  );
}

export default QROrder;
